// Web has no @react-native-firebase/storage build; the debug log panel is a
// native-only tester tool, so uploading is a no-op here to keep the web bundle
// free of native-module leaks.
export async function uploadLogs(): Promise<{ path: string; downloadUrl: string }> {
  throw new Error('Debug log upload is not supported on web.');
}
